<script setup lang="ts">
	import { computed } from 'vue';

	import GiftIcon from '~/assets/svg/gift.svg';
	import {useBookingStore} from "~/store";
	const { isRegular } = useBookingStore();

	// Props
	const props = defineProps<{
		coupon: string | null;
	}>();

	// Coupon code to message mapping
	const couponMessages: Record<
		string,
		{ message: string; type: 'success' | 'info' }
	> = {
		'4XZJ9KL78Q': {
			message: 'Extra hour free on your first service!',
			type: 'success',
		},
	};

	const isValidCoupon = (code: string | null) => {
		if (!code) return false;
		const upper = code.toUpperCase();
		return Object.keys(couponMessages).includes(upper) && isRegular();
	};

	const getCouponMessage = (code: string | null) => {
		if (!code) return null;
		const upper = code.toUpperCase();
		return (
			couponMessages[upper] || { message: 'Coupon applied!', type: 'success' }
		);
	};

	const couponMessage = computed(() => getCouponMessage(props.coupon));
</script>

<template>
	<div
		v-if="coupon && isValidCoupon(coupon)"
		class="col-span-2 relative flex items-center gap-4 bg-green-50 border border-green-200 rounded-lg p-2 shadow-sm mt-2"
		role="status"
		aria-live="polite">
		<div class="flex-shrink-0">
			<GiftIcon
				class="w-8 h-8 text-green-400"
				aria-hidden="true" />
		</div>
		<div class="flex-1 min-w-0">
			<div class="flex flex-col items-start gap-1">
				<span class="text-green-800 font-bold text-sm mb-1 block">
					Coupon Applied
				</span>
				<span
					class="text-xs font-semibold bg-green-200 text-green-800 px-2 py-0.5 rounded uppercase tracking-wide"
					style="letter-spacing: 0.05em">
					{{ coupon }}
				</span>
				<span
					v-if="couponMessage"
					class="text-green-700 font-medium text-sm mt-1 block">
					{{ couponMessage.message }}
				</span>
			</div>
		</div>
	</div>
</template>
